import { DateTime, Duration, DateTimeUnit } from "luxon";

export function roundUpToNearest<IsValid extends boolean>(m: DateTime<IsValid>, precision: number, unit: DateTimeUnit): DateTime<IsValid> {
    const duration = Duration.fromObject({ [unit]: precision });
    const remainder = duration.as("minutes") - (m.diff(m.startOf(unit), unit).as("minutes") % duration.as("minutes"));
    return m.plus({ [unit]: remainder }).startOf(unit);
}

export function roundDownToNearest<IsValid extends boolean>(m: DateTime<IsValid>, precision: number, unit: DateTimeUnit): DateTime<IsValid> {
    if (unit === "week") {
        throw new Error("unit can't be week");
    }
    const remainder = m.get(unit) % precision;
    return m.minus({ [unit]: remainder }).startOf(unit);
}
